import React from 'react'
import { Form } from './Form'
import { Container } from './styles'

const Recommendation: React.FC = () => {
  return (
    <Container>
      <Form></Form>
    </Container>
  )
}

export default Recommendation
